const increment = 2; // Frames per step. Must be >= 2

export class EncryptedTitleHTMLElement extends HTMLElement {

    private output: HTMLElement;
    private stepIndex = 0;
    private stringIndex = 0;
    private changing = "";
    private fixed = "";

    private rustle = (i: number) => {
        setTimeout(() => {
            const title = this.title;
            const tLength = title.length;
            for (let i1 = this.stringIndex; i1 < tLength; i1++) {
                const ch = title[i1];
                this.changing += ch.match(/\n|\s|,/)
                    ? ch
                    : String.fromCharCode((ch >= 'A' && ch <= 'Z' ? 65 : 97) + Math.floor(26 * Math.random()));
            }

            if (this.stepIndex === increment - 1) {
                this.stringIndex++;
            } else if (this.stepIndex === increment) {
                this.fixed += title[this.stringIndex - 1];
                this.stepIndex = 0;
            }

            this.output.textContent = this.fixed + this.changing;

            this.changing = "";
            this.stepIndex += 1;
            if (--i) {
                this.rustle(i);
            }
        }, 5);
    }

    private animateTitle = (): void => {
        this.rustle(this.title.length * increment + 1);

        this.stepIndex = 0;
        this.stringIndex = 0;
        this.changing = "";
        this.fixed = "";
        this.onmouseenter = undefined;
    }

    public connectedCallback(): void {
        this.output = this.querySelector<HTMLElement>(".output");
        this.onmouseenter = this.animateTitle;
    }

    public disconnectedCallback(): void {
        this.onmouseenter = undefined;
    }
}
